<template>
  <div v-if="hasItems" class="d-flex gap-1 flex-wrap">
    <el-tag
      v-for="brand in brands"
      :key="brand.id"
      size="small"
      type="info"
    >
      {{ brand.title }}
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    brands: Array,
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasItems() {
      return !_.isEmpty(this.brands);
    },
  },
}
</script>

<style scoped>

</style>
